import { PATROL_STATUS_DEFAULT_FILTERS } from 'utils/constants/patrol';
import { USER_FIELDS } from 'utils/formFields/user';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';

const AvailableFilters = {
  archive: {
    label: 'Archived',
    field: 'archived',
    type: 'toggle',
  },
  status: {
    label: 'status',
    field: 'status',
    type: 'select',
    options: PATROL_STATUS_DEFAULT_FILTERS,
    multiple: true,
  },
  dateFrom: {
    label: 'dateFrom',
    field: 'dateFrom',
    type: 'date-picker',
  },
  dateTo: {
    label: 'dateTo',
    field: 'dateTo',
    type: 'date-picker',
  },
};

export const filters = ({ securityCompanyId, userAssignedDepartments }) => {
  const { status, dateFrom, dateTo } = AvailableFilters;

  const filters = {
    RegularFilters: [status, dateFrom, dateTo],
    AdvancedFilters: [
      USER_FIELDS.businessClient({
        archived: false,
        securityCompanyId,
      }),
      ...departmentFilter(userAssignedDepartments),
    ],
  };

  return filters;
};
